// Mock data for Affordable ServiceTech Inc. landing page

export const heroContent = {
  headline: "Axis Affordable ServiceTech Inc.",
  subheading: "Building the Operating System behind service marketplaces that scale.",
  supportingText: "We design, launch, and scale managed service marketplaces that combine technology, operations, and distributed workforces into a repeatable, high performing operating system."
};

export const whatWeBuilding = {
  title: "What We're Building",
  description: "Axis Affordable ServiceTech Inc. (AAST) is a parent operating company focused on building and operating high performing managed service marketplaces in the home/local service sector.\n\nOur proprietary approach leverages shared infrastructure, unified workforce systems, intelligent pricing logic, and coordinated regional operations to create scalable, efficient platforms. Each marketplace benefits from our proven operating system while maintaining its own brand identity and market focus."
};

export const marketplaceBrands = [
  {
    id: 1,
    name: "$20 Clean",
    status: "live",
    label: "$20 Clean – Live",
    logoPlaceholder: true,
    logoUrl: "https://customer-assets.emergentagent.com/job_tech-marketplace-65/artifacts/64u7trqk_%2420%20Cleaners%20Toronto%20logo.png",
    link: "https://20dollarclean.ca"
  },
  {
    id: 2,
    name: "Handyman Dan",
    status: "upcoming",
    label: "Handyman Dan",
    logoPlaceholder: false,
    logoUrl: "https://customer-assets.emergentagent.com/job_tech-marketplace-65/artifacts/rkv8pj69_Orange%20and%20Blue%20Retro%20Illustrative%20Cleaning%20Handyman%20Delivery%20Platform%20Logo.png"
  },
  {
    id: 3,
    name: "Auto911",
    status: "upcoming",
    label: "Auto911",
    logoPlaceholder: false,
    logoUrl: "https://customer-assets.emergentagent.com/job_tech-marketplace-65/artifacts/bjldsq85_IMG_3066.png"
  }
];

export const footerContent = {
  companyName: "Axis Affordable ServiceTech Inc.",
  year: new Date().getFullYear()
};
